import React from "react";
import { connect } from "react-redux";
import { Form } from "../../lib";
import { createUser } from "../../reducers/user/actions";
import { Constraints, Fields } from "./types";

export const EVT_USER_REGISTER = "user/REGISTER";

const mapDispatch = { createUser };
type DispatchProps = typeof mapDispatch;
type OwnProps = {
    redirect: boolean;
    primaryBtnType?: string;
};
type Props = DispatchProps & OwnProps;

class RegisterForm extends React.Component<Props> {
    private order = ["name", "email"];

    private fields: Fields = {
        name: {
            type: "text",
        },
        email: {
            type: "email",
        },
    };

    private constraints: Constraints = {
        name: {
            presence: { message: "nameRequired" },
            length: {
                minimum: 3,
                message: "nameMinChars",
            },
        },

        email: {
            presence: { message: "emailRequired" },
            email: { message: "emailInvalid" },
        },
    };

    onSubmit = (values: Record<string, any>) => {
        const { createUser, redirect } = this.props;
        createUser({
            ...values,
            redirect,
            password: Math.random().toString(36).substr(2),
        });

        const { gtag } = window;
        gtag("event", "user", {
            event_category: "form",
            event_label: "register",
        });
    };

    render() {
        return (
            <Form
                id="register"
                order={this.order}
                fields={this.fields}
                constraints={this.constraints}
                focusOnFirst={true}
                onSubmit={this.onSubmit}
                primaryBtnType={this.props.primaryBtnType}
            />
        );
    }
}

export default connect(null, mapDispatch)(RegisterForm);
